var render = function render(_c, _vm) {
  return _c("modals-container", { staticClass: "c-modalsContainer" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }